const STORAGE_KEY = "bff-viewer-highlight-field-slots";

let enabled = readEnabled();
let slotIds = new Set<string>();

function readEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function isFieldSlotHighlightEnabled(): boolean {
  return enabled;
}

export function setFieldSlotHighlight(on: boolean, ids: string[]): void {
  enabled = on;
  slotIds = new Set(ids);
  try {
    if (on) localStorage.setItem(STORAGE_KEY, "1");
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private mode */
  }
  applyFieldSlotHighlight();
}

/** Keep the id set in sync after a repaint without changing the toggle. */
export function syncFieldSlotHighlight(ids: string[]): void {
  slotIds = new Set(ids);
  applyFieldSlotHighlight();
}

export function applyFieldSlotHighlight(): void {
  const roots = document.querySelectorAll("#preview, .page-canvas");
  for (const root of roots) {
    root.querySelectorAll(".hv-field-bind").forEach((el) => {
      el.classList.remove("hv-field-bind");
    });
    if (!enabled) continue;
    for (const id of slotIds) {
      root.querySelectorAll(`[id="${CSS.escape(id)}"]`).forEach((el) => {
        el.classList.add("hv-field-bind");
      });
    }
  }
}
